import { NgModule } from '@angular/core';
import { CommonModule, LowerCasePipe } from '@angular/common';
import { LocalizedDatePipe } from 'src/app/modules/pipe/localized-date.pipe';
import { CapitalizeFirstPipe } from 'src/app/modules/pipe/capitalizefirst.pipe';

@NgModule({
  declarations: [
    LocalizedDatePipe,
    CapitalizeFirstPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    LocalizedDatePipe,
    CapitalizeFirstPipe,
    LowerCasePipe
  ]
})
export class PipeModule {
}
